{
  "companies": {
    "title": "Companies",
    "description": "Manage legal entities, calendars, and fiscal settings per company.",
    "addCompany": "Add company",
    "searchPlaceholder": "Search companies…",
    "editCompany": "Edit company",
    "newCompany": "New company",
    "columns": {
      "code": "Code",
      "name": "Name",
      "country": "Country",
      "currency": "Currency",
      "timezone": "Timezone",
      "default": "Default",
      "actions": "Actions"
    },
    "yes": "Yes",
    "no": "No",
    "edit": "Edit",
    "calendar": "Calendar",
    "workCalendar": {
      "title": "Work calendar",
      "titleWithCompany": "Work calendar — {{name}}",
      "assignPattern": "Assign week pattern",
      "assignPatternDesc": "Pick a saved pattern and apply it to this company's work calendar.",
      "weekPatternMaster": "Week pattern master",
      "selectPattern": "Select pattern…",
      "noPatterns": "No patterns — create one below",
      "assignButton": "Assign to work calendar",
      "weekPatternSection": "Week pattern master",
      "weekPatternSectionDesc": "Define working days and default hours. Reusable across schedules and attendance.",
      "holidayTypes": "Holiday types"
    },
    "users": "Users",
    "usersTitle": "User company mapping",
    "usersTitleWithName": "Map users — {{name}}",
    "userMappingHint": "Users listed here can switch into this company in the header. Operational data is scoped to the active company.",
    "mappedUsers": "Mapped users",
    "noUsersMapped": "No users mapped yet.",
    "defaultBadge": "default",
    "setDefault": "Set default",
    "depts": "Depts",
    "deptsTitle": "Department access",
    "fields": {
      "name": "Name",
      "code": "Code",
      "taxRegistration": "Tax registration",
      "registrationNumber": "Registration number",
      "email": "Email",
      "isDefault": "Default company",
      "isDefaultHint": "Mark as the organization default used after login. This replaces the default on any other company and updates users who follow the organization default.",
      "isDefaultLockedHint": "This is the current default. Set another company as default to change it."
    },
    "toast": {
      "created": "Company created — you are the first employee in {{name}}",
      "calendarUpdated": "Work calendar updated"
    },
    "errors": {
      "loadFailed": "Failed to load companies",
      "saveFailed": "Save failed",
      "selectWeekPattern": "Select a week pattern master",
      "calendarUpdateFailed": "Calendar update failed"
    }
  },
  "adminLinks": {
    "organization": {
      "label": "Organization",
      "description": "Profile, branding, and company details"
    },
    "companies": {
      "label": "Companies",
      "description": "Legal entities, calendars, and fiscal settings"
    },
    "enterpriseSetup": {
      "label": "Enterprise setup",
      "description": "Company → Store → Warehouse → Calendar → HR → Finance"
    },
    "users": {
      "label": "Users",
      "description": "Manage employees and access"
    },
    "roles": {
      "label": "Roles",
      "description": "Screen access and role templates"
    },
    "subscription": {
      "label": "Subscription",
      "description": "Plans, billing, and module usage"
    },
    "approvalInbox": {
      "label": "Approval inbox",
      "description": "Pending, approved, rejected, and escalated requests"
    },
    "approvalWorkflows": {
      "label": "Approval workflows",
      "description": "Create and manage approval chains without code"
    },
    "approvalMatrix": {
      "label": "Approval matrix",
      "description": "Module, action, conditions, approvers, SLA, escalation"
    }
  },
  "taxesPage": {
    "description": "Country-wise tax slabs linked to products via tax selection on the product form.",
    "columns": {
      "taxName": "Tax name",
      "inclusive": "Inclusive"
    },
    "toast": {
      "saved": "Tax saved"
    }
  },
  "taxRules": {
    "columns": {
      "country": "Country",
      "mode": "Mode",
      "ratePercent": "Rate %",
      "state": "State",
      "status": "Status",
      "taxName": "Tax name"
    },
    "toast": {
      "saved": "Tax rule saved"
    }
  },
  "toast": {
    "displaySettingsSaved": "Date & time display saved for {{company}}",
    "alreadyOnThisPlan": "Already on this plan",
    "subscriptionUpgraded": "Subscription upgraded",
    "offerSaved": "Offer saved",
    "couponSaved": "Coupon saved",
    "productDiscountUpdated": "Product discount updated",
    "serialRegistered": "Serial registered",
    "transferCancelled": "Transfer cancelled",
    "transferRequestCreatedDraft": "Transfer request created (draft)",
    "stockAdjustedTrackedInMovements": "Stock adjusted — tracked in Movements",
    "transferCompletedViaWorkflow": "Transfer completed via workflow",
    "transferSubmittedForApproval": "Transfer submitted for approval",
    "backorderAllocatedStockReserved": "Backorder allocated — stock reserved",
    "serialRetired": "Serial retired",
    "voidSubmittedForSupervisorApproval": "Void submitted for supervisor approval",
    "invoiceRestored": "Invoice restored",
    "voidReversalSubmittedForApproval": "Void reversal submitted for approval",
    "profileUpdated": "Profile updated",
    "alertSavedYouWillGetANotificationWhen": "Alert saved — you will get a notification when stock falls to this level",
    "brandAdded": "Brand added",
    "unitAdded": "Unit added",
    "exportedAsCsv": "Exported as CSV",
    "thisIsAlreadyYourCurrentPlan": "This is already your current plan",
    "requestSentOurTeamWillCreateAPlan": "Request sent — our team will create a plan for you",
    "userCanNowAccessThisCompany": "User can now access this company",
    "usersMappedToCompany": "{{count}} user(s) mapped to this company",
    "companyAccessRemoved": "Company access removed",
    "defaultCompanyUpdatedForUser": "Default company updated for user",
    "pagePinnedToFavorites": "Page pinned to favorites",
    "planActivated": "{{plan}} activated",
    "upgradedToPlan": "Upgraded to {{plan}}",
    "exportedAs": "Exported as {{format}}",
    "returnProcessed": "Return {{returnNumber}} processed",
    "invoiceVoided": "Invoice {{invoiceNumber}} voided",
    "inventoryReportExported": "Inventory report exported ({{format}})",
    "transferAction": "Transfer {{action}}d",
    "modulePlanSet": "{{module}} plan set to {{plan}}",
    "customerActivated": "Customer activated",
    "customerDeactivated": "Customer deactivated",
    "productActivated": "Product activated",
    "productDeactivated": "Product deactivated",
    "brandActivated": "Brand activated",
    "brandDeactivated": "Brand deactivated",
    "unitActivated": "Unit activated",
    "unitDeactivated": "Unit deactivated",
    "employeeCreated": "Employee created",
    "employeeUpdated": "Employee updated",
    "walletToppedUp": "Wallet topped up",
    "walletDebited": "Wallet debited",
    "autoRenewEnabled": "Auto-renew enabled",
    "autoRenewDisabled": "Auto-renew disabled",
    "supplierActivated": "Supplier activated",
    "supplierDeactivated": "Supplier deactivated",
    "supplierSaved": "Supplier saved",
    "storeActivated": "Store activated",
    "storeDeactivated": "Store deactivated",
    "storeSaved": "Store saved",
    "taxRuleActivated": "Tax rule activated",
    "taxRuleDeactivated": "Tax rule deactivated",
    "taxActivated": "Tax activated",
    "taxDeactivated": "Tax deactivated",
    "categoryActivated": "Category activated",
    "categoryDeactivated": "Category deactivated",
    "storeProductActivated": "Store product activated",
    "storeProductDeactivated": "Store product deactivated",
    "roleActivated": "Role activated",
    "roleDeactivated": "Role deactivated",
    "alertRemoved": "Alert removed",
    "categorySaved": "Category saved",
    "storeProductSaved": "Store product saved"
  },
  "errors": {
    "failedToSaveDisplaySettings": "Failed to save display settings",
    "paymentCouldNotBeStarted": "Payment could not be started",
    "failedToLoadBilling": "Failed to load billing",
    "failedToLoadModulePlans": "Failed to load module plans",
    "paymentVerificationFailed": "Payment verification failed",
    "upgradeFailed": "Upgrade failed",
    "modulePlanUpdateFailed": "Module plan update failed",
    "brandNameIsRequired": "Brand name is required",
    "saveFailed": "Save failed",
    "enterAPositiveAmount": "Enter a positive amount",
    "walletUpdateFailed": "Wallet update failed",
    "offerNameIsRequired": "Offer name is required",
    "enterAValidDiscountValue": "Enter a valid discount value",
    "percentageCannotExceed100": "Percentage cannot exceed 100",
    "couponCodeIsRequired": "Coupon code is required",
    "enterAPercentageBetween0And100": "Enter a percentage between 0 and 100",
    "updateFailed": "Update failed",
    "selectACompanyInTheHeaderBeforeAdding": "Select a company in the header before adding employees",
    "selectARoleWhenEmailIsProvided": "Select a role when email is provided",
    "reportingManagerIsRequired": "Reporting manager is required",
    "productAndSerialNumberRequired": "Product and serial number required",
    "selectDestinationStoreAndProduct": "Select destination store and product",
    "enterAValidQuantity": "Enter a valid quantity",
    "failedToLoadReadinessReports": "Failed to load readiness reports",
    "registerSerialFailed": "Register serial failed",
    "exportFailed": "Export failed",
    "cancelTransferFailed": "Cancel transfer failed",
    "createTransferRequestFailed": "Create transfer request failed",
    "adjustFailed": "Adjust failed",
    "transferFailed": "Transfer failed",
    "transferActionFailed": "Transfer {{action}} failed",
    "allocateBackorderFailed": "Allocate backorder failed",
    "enterReturnQuantitiesForAtLeastOneLine": "Enter return quantities for at least one line",
    "failedToLoadInvoice": "Failed to load invoice",
    "returnFailed": "Return failed",
    "printFailed": "Print failed",
    "voidFailed": "Void failed",
    "restoreFailed": "Restore failed",
    "orgCodeMustBe13UppercaseLetters": "Org code must be 1–3 uppercase letters or digits",
    "failedToLoadOrganization": "Failed to load organization",
    "selectAProduct": "Select a product",
    "failedToLoadAlerts": "Failed to load alerts",
    "removeFailed": "Remove failed",
    "unitNameIsRequired": "Unit name is required",
    "skuAndNameAreRequired": "SKU and name are required",
    "couldNotAddBrand": "Could not add brand",
    "couldNotAddUnit": "Could not add unit",
    "selectAStoreForFinancialReports": "Select a store for financial reports",
    "selectAStoreInTheHeaderForLow": "Select a store in the header for low stock report",
    "pdfExcelExportIsAvailableForSalesAnd": "PDF/Excel export is available for Sales and Inventory tabs only",
    "loadProductSalesReportFirst": "Load product sales report first",
    "loadProfitReportFirst": "Load profit report first",
    "loadTaxReportFirst": "Load tax report first",
    "loadLowStockReportFirst": "Load low stock report first",
    "loadExpiryReportFirst": "Load expiry report first",
    "loadEmployeeSalesReportFirst": "Load employee sales report first",
    "failedToLoadReport": "Failed to load report",
    "roleNameAndCodeAreRequired": "Role name and code are required",
    "screenAccessIsStillLoading": "Screen access is still loading",
    "failedToLoadRoleScreenAccess": "Failed to load role screen access",
    "failedToLoadRole": "Failed to load role",
    "storeAndProductAreRequired": "Store and product are required",
    "nameAndCodeAreRequired": "Name and code are required",
    "yourAccountEmailIsRequiredToSubmitA": "Your account email is required to submit a request",
    "failedToLoadPlans": "Failed to load plans",
    "paymentReceivedButActivationFailedContactSupport": "Payment received but activation failed. Contact support.",
    "couldNotUpdateAutoRenew": "Could not update auto-renew",
    "couldNotSubmitRequest": "Could not submit request",
    "taxNameIsRequired": "Tax name is required",
    "failedToLoadAccessData": "Failed to load access data",
    "failedToLoadDepartmentAccess": "Failed to load department access",
    "failedToLoadCompanyAccess": "Failed to load company access",
    "failedToGrantAccess": "Failed to grant access",
    "failedToRevokeAccess": "Failed to revoke access",
    "failedToSetDefault": "Failed to set default",
    "thisPageIsNotAvailableInYourCurrent": "This page is not available in your current module.",
    "returnQtyExceedsSold": "Return qty exceeds sold for {{product}}",
    "failedToLoadBrands": "Failed to load brands",
    "failedToLoadCategories": "Failed to load categories",
    "failedToLoadCustomers": "Failed to load customers",
    "failedToLoadOffers": "Failed to load offers",
    "failedToLoadCoupons": "Failed to load coupons",
    "failedToLoadProducts": "Failed to load products",
    "failedToLoadEmployees": "Failed to load employees",
    "failedToLoadInventory": "Failed to load inventory",
    "failedToLoadStockMovements": "Failed to load stock movements",
    "failedToLoadTransferRequests": "Failed to load transfer requests",
    "failedToLoadBackorders": "Failed to load backorders",
    "failedToLoadSerialNumbers": "Failed to load serial numbers",
    "failedToLoadInvoices": "Failed to load invoices",
    "failedToLoadRoles": "Failed to load roles",
    "failedToLoadStoreProducts": "Failed to load store products",
    "failedToLoadStores": "Failed to load stores",
    "failedToLoadSuppliers": "Failed to load suppliers",
    "failedToLoadTaxes": "Failed to load taxes",
    "failedToLoadTaxRules": "Failed to load tax rules",
    "failedToLoadUnits": "Failed to load units",
    "activateFailed": "Activate failed",
    "deactivateFailed": "Deactivate failed",
    "createFailed": "Create failed",
    "passwordsMismatch": "Passwords do not match"
  },
  "roles": {
    "addRole": "Add role",
    "columns": {
      "type": "Type",
      "roleName": "Role name",
      "code": "Code",
      "description": "Description",
      "status": "Status",
      "screenAccess": "Screen access",
      "screensCount": "{{visible}}/{{total}} screens",
      "builtIn": "Built-in",
      "custom": "Custom"
    },
    "actions": {
      "view": "View",
      "edit": "Edit",
      "close": "Close",
      "editScreenAccess": "Edit screen access",
      "save": "Save",
      "createRole": "Create role"
    },
    "viewModal": {
      "title": "{{name}} — screen access",
      "titleFallback": "Role screen access",
      "loading": "Loading…",
      "codeLabel": "Code:",
      "descriptionLabel": "Description:",
      "screensLabel": "Screens:",
      "screensVisible": "{{visible}}/{{total}} visible"
    },
    "editModal": {
      "editBuiltIn": "Edit {{name}} screen access",
      "editRole": "Edit role",
      "newRole": "New role",
      "activeRole": "Active role",
      "builtInHint": "Built-in role — adjust screen access below. Name and code are fixed.",
      "loadingScreens": "Loading screens…"
    },
    "toast": {
      "saved": "Role saved — users with this role should sign in again (or refresh) to update navigation",
      "created": "Role created — assign it to employees from Users"
    },
    "assignable": {
      "label": "Role",
      "labelRequired": "Role *",
      "loading": "Loading roles…",
      "empty": "No roles available",
      "placeholderWithEmail": "Select role for app login",
      "placeholderOptional": "Select role (optional without email)",
      "builtInSuffix": "(built-in)",
      "createRolesHint": "Create roles under",
      "adminRolesLink": "Administration → Roles",
      "createRolesHintSuffix": "first, then return here to assign them.",
      "requiredWithEmail": "Required when an email is set — controls app login access."
    }
  },
  "permissions": {
    "actions": {
      "view": "View",
      "create": "Create",
      "edit": "Edit",
      "delete": "Delete"
    },
    "hints": {
      "view": "Show in navigation and open the page",
      "create": "Show create / add actions on this screen",
      "edit": "Show edit / update actions on this screen",
      "delete": "Show delete / remove actions on this screen",
      "alwaysVisible": "Always visible — no view permission required; sign-in only",
      "hiddenFromNav": "Hidden from navigation",
      "applicationAccess": "Allow sign-in and show in app switcher when enabled with another app"
    },
    "open": "Open",
    "selectAll": "Select all",
    "deselectAll": "Deselect all",
    "all": "All",
    "none": "None",
    "screen": "Screen",
    "application": "Application",
    "applicationsModule": "Applications",
    "applicationsEnabled": "applications enabled",
    "screensVisibleLabel": "screens visible",
    "visibleInNav": "{{visible}} of {{total}} screens visible in navigation",
    "bulkHint": "Top Select all / Deselect all applies to every module. Each accordion heading applies to that whole module only. Column and row controls apply to that module section.",
    "applicationsHint": "Applications lists every module your organization subscribes to. Enable View on each app this role may open. One enabled app — users land there directly with no switcher. Two or more — the app switcher appears in the sidebar.",
    "noSearchResults": "No screens match your search.",
    "ariaActionOnScreen": "{{action}} on {{screen}}"
  },
  "reports": {
    "tabs": {
      "sales": "Sales",
      "products": "Product Sales",
      "profit": "Profit",
      "tax": "Tax",
      "inventory": "Inventory",
      "lowstock": "Low Stock",
      "expiry": "Expiry",
      "employees": "Employee Sales"
    },
    "actions": {
      "generate": "Generate"
    },
    "sections": {
      "dailyBreakdown": "Daily breakdown"
    },
    "descriptions": {
      "selectStore": "Select a store in the header for financial reports",
      "storeSelected": "{{name}} · {{currency}} — financial reports require a store",
      "profitCalculation": "Profit per product = sales revenue (from invoices) minus cost (purchase unit price × qty sold). Record purchases in Inventory so cost price updates; selling price comes from POS / store product.",
      "lowStockPrefix": "Uses thresholds from",
      "lowStockSuffix": "for the selected store. Cost and stock value on the Inventory tab come from purchases / store product cost."
    },
    "columns": {
      "sku": "SKU",
      "product": "Product",
      "qtySold": "Qty Sold",
      "revenue": "Revenue",
      "metric": "Metric",
      "value": "Value",
      "cost": "Cost",
      "profit": "Profit",
      "taxRatePercent": "Tax rate %",
      "taxable": "Taxable",
      "taxAmount": "Tax amount",
      "onHand": "On hand",
      "alertQty": "Alert qty",
      "need": "Need",
      "batch": "Batch",
      "expiry": "Expiry",
      "qty": "Qty",
      "daysLeft": "Days left",
      "employee": "Employee",
      "invoices": "Invoices",
      "sales": "Sales",
      "avgSell": "Avg sell",
      "unitCost": "Unit cost",
      "marginPercent": "Margin %",
      "ratePercent": "Rate %",
      "tax": "Tax",
      "lines": "Lines"
    }
  },
  "inventory": {
    "tabs": {
      "stock": "Stock",
      "movements": "Movements",
      "transfers": "Transfer requests",
      "backorders": "Backorders",
      "serials": "Serial numbers",
      "readiness": "Readiness"
    },
    "columns": {
      "serialNumber": "Serial #",
      "product": "Product",
      "status": "Status",
      "soldOnInvoice": "Sold on invoice",
      "warrantyEnd": "Warranty end",
      "actions": "Actions",
      "qty": "Qty",
      "batch": "Batch",
      "expiry": "Expiry",
      "date": "Date",
      "type": "Type",
      "storeRoute": "Store / Route",
      "notes": "Notes",
      "code": "Code",
      "route": "Route",
      "lines": "Lines",
      "created": "Created",
      "store": "Store",
      "reference": "Reference"
    },
    "actions": {
      "ledger": "Ledger",
      "transfer": "Transfer",
      "adjust": "Adjust",
      "refresh": "Refresh",
      "exportPdf": "Export PDF",
      "exportExcel": "Export Excel",
      "exportCsv": "Export CSV",
      "retire": "Retire",
      "submit": "Submit",
      "approve": "Approve",
      "dispatch": "Dispatch",
      "receive": "Receive",
      "allocate": "Allocate",
      "cancel": "Cancel",
      "applyAdjustment": "Apply adjustment",
      "transferWorkflow": "Transfer (workflow)",
      "submitTransfer": "Submit transfer"
    },
    "messages": {
      "reportExportRequiresPermission": "Report export requires REPORT_VIEW permission",
      "selectStoreFromHeader": "Select a store from the header.",
      "currentStore": "Current store:",
      "runningReadinessChecks": "Running inventory integrity and readiness checks…",
      "openReadinessPrompt": "Open this tab or click Refresh to run enterprise readiness checks.",
      "fromStore": "From:",
      "usesTransferWorkflow": "uses transfer workflow",
      "autoApproveFlow": " (auto-approve, dispatch & receive)",
      "pendingApprovalFlow": " (pending approval if required)"
    },
    "howItWorks": {
      "title": "How inventory works",
      "stock": "on-hand qty per product, batch, and expiry (separate rows per batch).",
      "adjust": "correction in/out; logged as ADJUSTMENT_IN / ADJUSTMENT_OUT in Movements.",
      "transfer": "workflow only: create → submit → approve → dispatch → receive (auto-completes if you can approve).",
      "heldBillsTitle": "Held bills (POS)",
      "heldBills": "reserves stock until checkout or restore.",
      "procurementGrnTitle": "Procurement GRN",
      "procurementGrn": "canonical stock-in (legacy purchase create is disabled).",
      "serials": "register units; POS checkout passes per line",
      "salesTitle": "Sales",
      "sales": "POS checkout deducts stock automatically (SALE transactions in Movements)."
    },
    "transactionTypes": {
      "adjustmentIn": "Adjustment (+)",
      "adjustmentOut": "Adjustment (-)",
      "transferIn": "Transfer in",
      "transferOut": "Transfer out",
      "purchase": "Purchase",
      "sale": "Sale",
      "return": "Return"
    },
    "transferStatuses": {
      "draft": "Draft",
      "pendingApproval": "Pending approval",
      "approved": "Approved",
      "inTransit": "In transit",
      "received": "Received",
      "cancelled": "Cancelled"
    },
    "adjustment": {
      "increase": "Increase stock (ADJUSTMENT_IN)",
      "decrease": "Decrease stock (ADJUSTMENT_OUT)"
    }
  },
  "discounts": {
    "actions": {
      "edit": "Edit"
    },
    "columns": {
      "catalogDiscountPercent": "Catalog discount %",
      "couponCode": "Coupon code",
      "discountType": "Discount type",
      "festivalOffer": "Festival offer",
      "maxUses": "Max uses",
      "offerName": "Offer name",
      "productName": "Product name",
      "sku": "SKU",
      "timesUsed": "Times used",
      "value": "Value"
    },
    "discountTypes": {
      "flatAmount": "Flat amount",
      "percentage": "Percentage",
      "percentageWithSymbol": "Percentage (%)"
    },
    "empty": {
      "noCoupons": "No coupons found",
      "noOffers": "No offers found",
      "noProducts": "No products found"
    },
    "help": {
      "couponCheckout": "Used at POS checkout when the cashier enters this coupon code.",
      "flatOffer": "Flat amount is subtracted from the cart subtotal (capped at subtotal).",
      "percentageOffer": "Percentage is taken off the eligible cart subtotal.",
      "productCatalogDiscount": "Default discount applied to this product in the catalog (separate from offers and coupons)."
    },
    "labels": {
      "markFestivalOffer": "Mark as festival / seasonal offer",
      "product": "Product"
    },
    "modal": {
      "editCoupon": "Edit coupon",
      "editOffer": "Edit offer",
      "newCoupon": "New coupon",
      "newOffer": "New offer"
    },
    "search": {
      "coupons": "Search coupons",
      "offers": "Search offers",
      "products": "Search products"
    },
    "tabs": {
      "coupons": "Coupons",
      "offers": "Offers",
      "products": "Product %"
    },
    "values": {
      "no": "No",
      "yes": "Yes"
    }
  },
  "billing": {
    "actions": {
      "backToAdministration": "← Back to Administration",
      "current": "Current",
      "currentPlan": "Current plan",
      "selectPlan": "Select plan",
      "upgrade": "Upgrade"
    },
    "billingCycles": {
      "monthly": "Monthly",
      "yearly": "Yearly"
    },
    "columns": {
      "amount": "Amount",
      "appEnabled": "App enabled",
      "date": "Date",
      "description": "Description",
      "module": "Module",
      "plan": "Plan",
      "status": "Status"
    },
    "description": "Organization plan, per-module subscriptions, usage quotas, and payment history.",
    "descriptionForModule": "Plans, usage, and billing for {{module}}. Feature access follows the active module plan.",
    "empty": {
      "noMeters": "No meters configured yet.",
      "noModuleSubscription": "No {{module}} subscription",
      "noModuleSubscriptions": "No module subscriptions",
      "noPayments": "No payments yet"
    },
    "labels": {
      "employeesWithValue": "Employees: {{value}}",
      "limits": "Limits — stores: {{storesUsed}}/{{maxStores}}, employees: {{employeesUsed}}/{{maxEmployees}}, products: {{productsUsed}}/{{maxProducts}}",
      "noEndDate": "No end date",
      "organizationPlan": "Organization plan",
      "platform": "Platform",
      "productsWithValue": "Products: {{value}}",
      "renewsOrEnds": "Renews / ends {{date}}",
      "statusWithValue": "Status: {{status}}",
      "storesWithValue": "Stores: {{value}}"
    },
    "loading": {
      "billing": "Loading billing…",
      "plans": "Loading plans…"
    },
    "sections": {
      "changeModulePlan": "Change module plan",
      "currentSubscription": "Current subscription",
      "moduleSubscriptions": "Module subscriptions",
      "orgWidePlatformPlan": "Org-wide platform plan",
      "paymentHistory": "Payment history",
      "usageQuotas": "Usage & quotas"
    },
    "title": "Billing & Subscriptions",
    "titleForModule": "{{module}} subscription",
    "values": {
      "free": "Free",
      "no": "No",
      "pricePerMonth": "{{price}} / mo",
      "pricePerYear": "{{price}} / yr",
      "usedOfUnlimited": "{{used}} / unlimited",
      "yes": "Yes"
    }
  },
  "subscription": {
    "actions": {
      "current": "Current",
      "currentPlan": "Current plan",
      "requestCustomPlan": "Request custom plan",
      "upgrade": "Upgrade",
      "useFreePlan": "Use free plan"
    },
    "badges": {
      "alwaysFree": "Always free"
    },
    "billingCycles": {
      "monthly": "Monthly",
      "yearly": "Yearly"
    },
    "columns": {
      "amount": "Amount",
      "date": "Date",
      "details": "Details",
      "plan": "Plan",
      "status": "Status"
    },
    "help": {
      "autoRenew": "Auto-renew monthly (Razorpay). When enabled, your plan extends automatically each billing period.",
      "customPlanContact": "We will contact you at your login email. Limits and notes are sent to our team for review.",
      "customPlanReady": "Your custom plan is ready — select it in the plans grid below.",
      "freePlanUpgrade": "You are on the free plan. Upgrade anytime for more stores, staff, and products.",
      "requestPendingReview": "Request pending review (submitted {{date}})."
    },
    "labels": {
      "status": "Status: {{status}}",
      "validUntil": "Valid until {{date}}"
    },
    "loading": "Loading...",
    "periods": {
      "month": "month",
      "year": "year"
    },
    "sections": {
      "billingHistory": "Billing history",
      "currentPlan": "Current plan",
      "needCustomPlan": "Need a custom plan?",
      "planUsage": "Plan usage"
    },
    "values": {
      "free": "Free",
      "freePlan": "Free Plan"
    }
  },
  "stores": {
    "breadcrumbs": {
      "pos": "POS",
      "stores": "Stores"
    },
    "columns": {
      "city": "City",
      "code": "Code",
      "country": "Country",
      "currency": "Currency",
      "name": "Name",
      "phone": "Phone",
      "status": "Status",
      "tax": "Tax"
    },
    "empty": {
      "noStores": "No stores found"
    },
    "searchPlaceholder": "Search stores",
    "taxPricing": {
      "exclusive": "Tax exclusive",
      "inclusive": "Tax inclusive"
    }
  },
  "suppliers": {
    "columns": {
      "name": "Name",
      "phone": "Phone",
      "outstanding": "Outstanding",
      "status": "Status"
    }
  },
  "pages": {
    "pinPageToFavorites": "Pin page to favorites",
    "administration": "Administration",
    "brands": "Brands",
    "categories": "Categories",
    "customers": "Customers",
    "manageCustomerRecordsAndWalletBalances": "Manage customer records and wallet balances",
    "noCustomersYet": "No customers yet",
    "addYourFirstCustomerToTrack": "Add your first customer to track sales, loyalty, and wallet balance.",
    "discountsOffers": "Discounts & Offers",
    "productCatalogDiscount": "Product catalog discount",
    "manageOffersCouponCodesAndProduct": "Manage offers, coupon codes, and product-level discounts",
    "employees": "Employees",
    "appAccess": "App access",
    "password": "Password",
    "reportingLine": "Reporting line",
    "employmentStatus": "Employment status",
    "assignedStores": "Assigned stores",
    "setANewPasswordGenerateOne": "Set a new password, generate one, or email credentials to the employee.",
    "inventory": "Inventory",
    "adjustStock": "Adjust stock",
    "transferStock": "Transfer stock",
    "newTransferRequest": "New transfer request",
    "registerSerialNumber": "Register serial number",
    "invoices": "Invoices",
    "invoiceHistory": "Invoice history",
    "salesReturn": "Sales return",
    "organization": "Organization",
    "dashboard": {
      "title": "Dashboard",
      "posTitle": "POS Dashboard",
      "description": "Company-wide KPIs and per-store financial overview",
      "posDescription": "Store sales, inventory, and point-of-sale operations",
      "summaryLabel": "{{storeCount}} stores · {{employeeHeadcount}} employees",
      "today": "Today",
      "thisMonth": "This month",
      "invoicesToday": "Invoices today",
      "selectStoreForKpis": "Select a store to view store-level KPIs.",
      "lowStockAlert": "{{count}} product(s) below reorder level — review inventory alerts."
    },
    "salesByStore": "Sales by store",
    "storeKpis": "Store KPIs",
    "todaySInvoices": "Today's Invoices",
    "todaySSales": "Today's Sales",
    "monthSales": "Month Sales",
    "products": "Products",
    "eachStoreShownInItsOwn": "Each store shown in its own currency — never merged",
    "productAlerts": "Product alerts",
    "lowStockAlert": "Low stock alert",
    "addBrand": "Add brand",
    "addUnit": "Add unit",
    "noProductsYet": "No products yet",
    "addProductsToYourCatalogFor": "Add products to your catalog for POS and inventory.",
    "reports": "Reports",
    "totalSales": "Total Sales",
    "tax": "Tax",
    "discounts": "Discounts",
    "revenue": "Revenue",
    "cost": "Cost",
    "grossProfit": "Gross Profit",
    "margin": "Margin %",
    "taxableAmount": "Taxable Amount",
    "totalTax": "Total Tax",
    "stockValue": "Stock Value",
    "lowStock": "Low Stock",
    "lowStockItems": "Low stock items",
    "store": "Store",
    "rolesScreenAccess": "Roles & screen access",
    "rolesIntro": "Create roles and choose which screens each role can view, create, edit, or delete. Assign roles to employees from Users after saving.",
    "storeProducts": "Store Products",
    "linkCatalogProductsToAStore": "Link catalog products to a store with that store's selling price and optional barcode",
    "stores": "Stores",
    "retailLocationsWarehousesAndPosOutlets": "Retail locations, warehouses, and POS outlets",
    "subscription": "Subscription",
    "requestCustomPlan": "Request custom plan",
    "suppliers": "Suppliers",
    "taxRates": "Tax rates",
    "taxRules": "Tax Rules",
    "countryStateTaxRulesUsedBy": "Country/state tax rules used by stores at checkout",
    "units": "Units"
  },
  "labels": {
    "closeSidebar": "Close sidebar",
    "closeMenu": "Close menu",
    "toggleTheme": "Toggle theme",
    "dateFormat": "Date format",
    "timeFormat": "Time format",
    "dateAmpTimeFormat": "Date &amp; time format",
    "module": "Module",
    "billingCycle": "Billing cycle",
    "brandName": "Brand name *",
    "name": "Name *",
    "phone": "Phone",
    "email": "Email",
    "address": "Address",
    "transaction": "Transaction",
    "notes": "Notes",
    "offerName": "Offer name *",
    "discountType": "Discount type *",
    "minimumCartAmount": "Minimum cart amount",
    "specificProductOptional": "Specific product (optional)",
    "couponCode": "Coupon code *",
    "maximumUses": "Maximum uses",
    "discountPercentage": "Discount percentage *",
    "flatDiscountAmountRequired": "Flat discount amount *",
    "eGWeekendSale": "e.g. Weekend sale",
    "optional": "Optional",
    "allProductsIfEmpty": "All products if empty",
    "eGSave10": "e.g. SAVE10",
    "leaveEmptyForUnlimited": "Leave empty for unlimited",
    "validFrom": "Valid from",
    "validUntil": "Valid until",
    "firstName": "First name *",
    "lastName": "Last name",
    "initialPassword": "Initial password",
    "confirmPassword": "Confirm password",
    "status": "Status",
    "comments": "Comments",
    "loginEmailOptional": "Login email (optional)",
    "optionalAutoGeneratedIfBlank": "Optional — auto-generated if blank",
    "stockLine": "Stock line *",
    "direction": "Direction *",
    "quantity": "Quantity *",
    "batchNumber": "Batch number",
    "expiryDate": "Expiry date",
    "reasonNotes": "Reason / notes",
    "stockLineToTransfer": "Stock line to transfer *",
    "toStore": "To store *",
    "product": "Product *",
    "serialNumber": "Serial number *",
    "imeiOptional": "IMEI (optional)",
    "selectProductBatchRow": "Select product / batch row",
    "optionalUseForBatchTrackedProducts": "Optional — use for batch-tracked products",
    "eGDamagedGoodsStockCount": "e.g. Damaged goods, stock count correction",
    "selectProductBatch": "Select product / batch",
    "selectDestination": "Select destination",
    "destination": "Destination",
    "reasonOptional": "Reason (optional)",
    "returnQty": "Return qty",
    "reason": "Reason",
    "whyIsThisInvoiceBeingVoided": "Why is this invoice being voided?",
    "name2": "Name",
    "orgCode": "Org code",
    "gst": "GST",
    "city": "City",
    "state": "State",
    "pincode": "Pincode",
    "eGFat": "e.g. FAT",
    "alertWhenQuantityAtOrBelow": "Alert when quantity at or below *",
    "sku": "SKU *",
    "barcode": "Barcode",
    "category": "Category",
    "sellingPrice": "Selling price *",
    "mrp": "MRP",
    "taxRuleStoreCheckout": "Tax rule (store checkout)",
    "discount": "Discount %",
    "unitName": "Unit name *",
    "symbol": "Symbol",
    "defaultFromStoreCountry": "Default from store country",
    "code": "Code *",
    "roleName": "Role name *",
    "description": "Description",
    "eGSupervisor": "e.g. SUPERVISOR",
    "eGFloorSupervisor": "e.g. Floor Supervisor",
    "whatThisRoleIsFor": "What this role is for",
    "store": "Store",
    "storeBarcodeUniquePerStore": "Store barcode (unique per store)",
    "selectStore": "Select store…",
    "optionalUsedForPosScanAt": "Optional — used for POS scan at this store",
    "taxMode": "Tax mode",
    "prices": "Prices",
    "attendanceLocationOverride": "Attendance location override",
    "attendanceLocationOverrideHint": "When set, overrides the company location for employees assigned to this store.",
    "latitude": "Latitude",
    "longitude": "Longitude",
    "geoRadiusMeters": "Radius (m)",
    "stores": "Stores",
    "employees": "Employees",
    "products": "Products",
    "billingCyclePaidPlans": "Billing cycle (paid plans)",
    "yourEmailLoginAccount": "Your email (login account)",
    "phoneOptional": "Phone (optional)",
    "storesNeeded": "Stores needed",
    "employeesNeeded": "Employees needed",
    "productsNeeded": "Products needed",
    "requirements": "Requirements",
    "code2": "Code",
    "country": "Country",
    "rate": "Rate % *",
    "taxName": "Tax name *",
    "country2": "Country *",
    "stateCode": "State code",
    "selectTaxMode": "Select tax mode",
    "eGPiece": "e.g. Piece",
    "eGPcs": "e.g. pcs",
    "role": "Role",
    "login": "Login",
    "points": "Points",
    "wallet": "Wallet",
    "price": "Price",
    "unit": "Unit",
    "brand": "Brand",
    "system": "System"
  },
  "employmentStatuses": {
    "ACTIVE": "Active",
    "INACTIVE": "Inactive",
    "TERMINATED": "Terminated",
    "RESIGNED": "Resigned",
    "RETIRED": "Retired"
  },
  "employees": {
    "requirePasswordChangeOnNextSignIn": "Require password change on next sign-in",
    "temporaryPasswordWillBeEmailed": "If no password is set, a temporary password is emailed and the user must change it on first sign-in.",
    "statusTimeline": "Status timeline"
  },
  "invoices": {
    "columns": {
      "invoiceNumber": "Invoice #",
      "date": "Date",
      "total": "Total",
      "payment": "Payment",
      "status": "Status"
    },
    "actions": {
      "print": "Print",
      "pdf": "PDF",
      "void": "Void",
      "voidInvoice": "Void invoice",
      "restore": "Restore"
    },
    "selectStoreToViewHistory": "Select a store from the header to view invoice history.",
    "historyDescription": "{{store}} · {{currency}} — list, print, PDF, and sales returns",
    "invoiceTitle": "Invoice {{number}}",
    "invoiceTitleFallback": "Invoice",
    "detail": {
      "date": "Date:",
      "currency": "Currency:",
      "subtotal": "Subtotal:",
      "tax": "Tax:",
      "total": "Total:",
      "paid": "Paid:"
    },
    "payments": "Payments",
    "lineItems": "Line items",
    "taxPercent": " ({{percent}}% tax)",
    "returnHelp": "Stock will be restored. Refund adjusts payment status.",
    "returnHelpWithWallet": "Stock will be restored. Refund adjusts payment status and credits the customer wallet for wallet payments.",
    "refundPaymentWalletCredit": "Refund payment (wallet credit if paid via WALLET)",
    "soldQuantity": "Sold: {{quantity}}",
    "voidTitle": "Void {{number}}",
    "voidHelp": "Stock will be restored and the invoice marked cancelled. Supervisor approval may be required."
  },
  "productAlerts": {
    "columns": {
      "product": "Product",
      "sku": "SKU",
      "stockAlertAt": "Stock / Alert at",
      "active": "Active",
      "lastNotified": "Last notified"
    },
    "confirmRemove": "Remove this alert?",
    "selectStoreToManage": "Select a store in the header to manage low-stock alerts.",
    "description": "Low-stock thresholds for {{store}}. Alerts appear in notifications and repeat at most once per 24 hours."
  },
  "storeProducts": {
    "columns": {
      "product": "Product",
      "sku": "SKU",
      "barcode": "Barcode",
      "storeBarcode": "Store barcode",
      "sellingPrice": "Selling price",
      "mrp": "MRP",
      "status": "Status"
    },
    "storeProductFallback": "Store product",
    "infoTitle": "What is a store product?",
    "infoPrefix": "Your",
    "infoCatalogScope": "catalog is organization-wide (SKU, name, default price).",
    "storeProductTerm": "A store product",
    "infoDefinition": "is the same item enabled for one store with that store's selling price, MRP, and optional store barcode (must be unique within that store). POS and inventory for that store use these values; scan checks store barcode before catalog barcode. Create the product under Products first, then add it here for each store.",
    "sellingPriceCurrency": "Selling price ({{currency}}) *",
    "mrpCurrency": "MRP ({{currency}})",
    "storeBarcodeHelp": "Each store barcode can only be used once in this store. Leave empty to scan by catalog barcode from Products instead."
  },
  "categories": {
    "columns": {
      "name": "Name",
      "status": "Status"
    },
    "breadcrumbs": {
      "pos": "POS"
    }
  },
  "formActions": {
    "saveOffer": "Save offer",
    "saveCoupon": "Save coupon",
    "addOffer": "Add offer",
    "addCoupon": "Add coupon",
    "submitRequest": "Submit request",
    "submitReturn": "Submit return"
  },
  "listActions": {
    "addCustomer": "Add customer",
    "addProduct": "Add product",
    "addEmployee": "Add employee",
    "addCategory": "Add category",
    "addStore": "Add store",
    "addUnit": "Add unit",
    "addTax": "Add tax",
    "addTaxRule": "Add rule",
    "addStoreProduct": "Add pricing",
    "addAlert": "Add alert",
    "addBrand": "Add brand",
    "refundReturn": "Refund / Return",
    "registerSerial": "Register serial",
    "newCustomer": "New customer",
    "editCustomer": "Edit customer",
    "newProduct": "New product",
    "editProduct": "Edit product",
    "newEmployee": "New employee",
    "editEmployee": "Edit employee",
    "newCategory": "New category",
    "editCategory": "Edit category",
    "newStore": "New store",
    "editStore": "Edit store",
    "newUnit": "New unit",
    "editUnit": "Edit unit",
    "newTax": "New tax",
    "editTax": "Edit tax",
    "newTaxRule": "New tax rule",
    "editTaxRule": "Edit tax rule",
    "newStoreProduct": "New store product",
    "editStoreProduct": "Edit store product",
    "newBrand": "New brand",
    "editBrand": "Edit brand",
    "newSupplier": "New Supplier",
    "editSupplier": "Edit"
  }
}
